import { MediaPicker } from "./MediaPicker";
import { useAttachmentUploader } from "./useAttachmentUploader";

export interface AttachmentUploaderProps {
  name: string;
}

export interface AttachmentUploaderFormFields {
  [name: string]: {
    signed_id: string;
    url: string;
    filename: string;
    byte_size: number;
  };
}

export const AttachmentUploader = ({ name }: AttachmentUploaderProps) => {
  const {
    signed_id,
    url,
    filename,
    byte_size,
    handleOnUploadStarted,
    handleOnUploadComplete,
    handleOnClickRemove,
  } = useAttachmentUploader({ name });

  return (
    <div className="flex flex-col gap-5">
      <MediaPicker
        onUploadStarted={handleOnUploadStarted}
        onUploadComplete={handleOnUploadComplete}
        onClickRemove={handleOnClickRemove}
        file={{
          signed_id,
          url,
          filename,
          byte_size,
        }}
      />
    </div>
  );
};
